import { h } from 'preact'
import Icon from '../../../preact-components/assets'

const AnonymousUserCell = ({ customClass, iconSize = 16 }: {customClass: string, iconSize?: number}) => {
  return (
    <div className={customClass}>
      <div className='icon-user'>
        <Icon icon='user' height={iconSize} width={iconSize} color='#9599A2' />
      </div>
      <div>Anonymous</div>
    </div>
  )
}

export default AnonymousUserCell
